import React from 'react';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import { SortButtons } from '../../../../shared/components/buttons';
import { SortMethods } from '../../../../shared/hooks/useSort';
import { ReleaseSortField } from '../../../interfaces/ReleaseFilters';

type TitleRowProps = SortMethods<ReleaseSortField>;

const TitleRow = ({ handleSort, getIsSortedBy }: TitleRowProps) => (
  <GridTableRow variant="header">
    <GridTableCell>
      <SortButtons fieldName="platform" onSort={handleSort} getIsActive={getIsSortedBy}>
        Platform
      </SortButtons>
    </GridTableCell>
    <GridTableCell>Release Date</GridTableCell>
    <GridTableCell>Status</GridTableCell>
    <GridTableCell>Notes</GridTableCell>
    <GridTableCell justify="end">Video</GridTableCell>
  </GridTableRow>
);

export { TitleRow };
